import ModalBox from "../containers/modal-box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ContentState, convertToRaw, Editor, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import Select, { components } from "react-select";
import TextField from "@mui/material/TextField";
import { RiCloseLargeLine } from "react-icons/ri";
import {
  postAPIDraft,
  postAPIMessage,
  postAPIMessageBody,
  postAPIMessages,
  postAPIMessageSubjectCategory,
  postUserSettingsGlobalSidebar,
  postUserSettingsLocal
} from "../redux/actions";
import PopupAlert from "./PopupAlert";
import SimpleBackdrop from "./SimpleBackdrop";
import YesNoDialog from "./YesNoDialog";
import Dialog from "./modal-box/dialog";

// 25mb
const maxFileSize = 25 * 1048576;

const DropdownIndicator = ({ innerRef, innerProps }) => "";
const SelectContainer = ({ children, ...props }) => {
  return (
    <components.SelectContainer style={{ border: "0" }} {...props}>
      {children}
    </components.SelectContainer>
  );
};
class ContactUsContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      open: false,
      editorState: EditorState.createEmpty(),
      popupAlertOpen: false,
      popupAlertMessage: "",
      popupAlertIsSuccessMessage: false,
      circularProgressOpen: false,
      emailSend: false,
      optionSelected: "",
      modalBoxState: false,
      sections: [],
      sectionsOpen: [],
      otherSubject: "Other",
      dialogState: false
    };

    this.apiClass = props.apiClass;
    this.setEditor = (editor) => {
      this.editor = editor;
    };
    this.focusEditor = () => {
      if (this.editor) {
        this.editor.focus();
      }
    };
  }
  componentDidMount() {
    this.userTypeCheck();
    if (this.props.getAPIMessage == null) {
      this.props.postAPIMessage({
        toAddresses: [],
        body: "",
        subject: "",
        category: ""
      });
    }

    this.setState({
      editorState: EditorState.createWithContent(
        ContentState.createFromBlockArray(
          htmlToDraft(
            this.props.getAPIMessage ? this.props.getAPIMessage.body : ""
          )
        )
      )
    });
    this.updateOptions();
  }
  componentDidUpdate() {
    if (this.props.getAPIMessage == null) {
      this.props.postAPIMessage({
        toAddresses: [],
        body: "",
        subject: "",
        category: ""
      });
    }
  }
  setErrorMessageModal = (message, continuation) => {
    this.setState(
      {
        circularProgressOpen: false,
        popupAlertMessage: message,
        popupAlertOpen: true
      },
      continuation
    );
  };

  GetUserSettingsLocal = async () => {
    return await this.apiClass
      .GetUserSettings()
      .then((res) => this.props.postUserSettingsLocal(res.local.customData));
  };

  componentWillUnmount() {}
  setErrorMessage = (message, continuation) => {
    this.setState(
      {
        circularProgressOpen: false,
        errorMSG: message
        // popupAlertMessage: message,
        // popupAlertOpen: true,
      },
      continuation
    );
  };

  setSuccessMessage = (message, continuation) => {
    this.props.enqueueSnackbar(message, { variant: "success" });

    this.setState(
      {
        circularProgressOpen: false,
        popupAlertMessage: message,
        popupAlertOpen: true,
        popupAlertIsSuccessMessage: true
      },
      continuation
    );
  };
  resetBody() {
    this.props.postAPIMessageBody("");
    this.setState({
      modalBoxState: false,
      otherSubject: "Other",
      editorState: EditorState.createEmpty()
    });
  }
  formBuilder = () => {
    let defaultSubject = this.props.getAPIMessage.subject;
    let Body = this.props.getAPIMessage.body;
    let Subject =
      defaultSubject === "Other" ? this.state.otherSubject : defaultSubject;
    let Category = this.props.getAPIMessage.category;
    let ToAddresses = this.props.getAPIMessage.toAddresses;
    let Attachments = this.state.files;
    let Mailbox = this.props.getAPIMailbox;
    var form = new FormData();
    form.append("Body", Body);
    form.append("From", Mailbox);
    form.append("Subject", Subject);
    form.append("Category", Category);
    console.log("form ", form);
    if (ToAddresses) {
      for (let i = 0; i < ToAddresses.length; i++) {
        form.append("ToAddresses", ToAddresses[i]);
      }
    }

    if (Attachments) {
      for (let i = 0; i < Attachments.length; i++) {
        form.append("AttachmentFiles", Attachments[i]);
      }
    }
    let domain = window.location.host;
    if (domain.search("localhost") >= 0) domain = "devnexus.admis.com";
    form.append("Domain", domain);
    return form;
  };
  sendEmailConfirmed = () => {
    return this.setState(
      { emailSend: true, modalBoxState: false, circularProgressOpen: true },
      async () => {
        return await this.apiClass
          .PostMessage(this.formBuilder())
          .then((res) => {
            let continuation = () => {
              this.props.updateMessages();
              this.props.history.push(
                "/" + this.props.getAPIMailbox + "/inbox"
              );
            };
            if (res === "success") {
              const txt =
                "Message has been sent successfully and an ADMIS employee will be in touch with you soon";
              this.setSuccessMessage(txt, continuation);
              this.resetBody();
            } else {
              this.setState({
                circularProgressOpen: false
              });
            }
          });
      }
    );
  };

  sendMessage() {
    if (this.state.otherSubject === "") {
      this.inputRef.focus();
      this.setErrorMessageModal("Please enter a subject");
      return;
    }
    if (
      this.props.getAPIMessage.body === "" ||
      this.props.getAPIMessage.body === "\n"
    ) {
      this.setState({
        yesNoDialogOpen: true,
        yesNoDialogContent: "Do you want to send this message without a body?",
        yesNoDialogTitle: "Send Message"
      });
      this.focusEditor();
      return;
    }
    this.sendEmailConfirmed();
  }
  updateOptions = async () => {
    var sections = await this.apiClass.GetTopics();
    this.setState({ sections });
  };
  sectionClicked(clickedSection) {
    let clickedSectionName = clickedSection[0].category;
    let sectionsOpen = JSON.parse(JSON.stringify(this.state.sectionsOpen));
    if (this.state.sectionsOpen.length > 0) {
      // some sections open
      let foundIndex = sectionsOpen.findIndex(
        (eachSection) => eachSection === clickedSectionName
      );
      if (foundIndex > -1) {
        sectionsOpen.splice(foundIndex, 1);
      } else {
        sectionsOpen.push(clickedSectionName);
      }
    } else {
      // no section is open
      sectionsOpen.push(clickedSectionName);
    }

    this.setState({ sectionsOpen });
  }
  genCustomerSectionsList = () => {
    return (
      <>
        {this.state.sections.map((section) => (
          <>
            <div
              style={{
                marginTop: 20,
                marginBottom: 10,
                cursor: "pointer",
                flexDirection: "row",
                alignItems: "center",
                display: "flex",
                width: "content",
                height: "content"
              }}
              onClick={() => this.sectionClicked(section)}
            >
              {this.state.sectionsOpen.some(
                (i) => i === section[0].category
              ) ? (
                <ExpandLessIcon style={{ fontSize: 30 }} />
              ) : (
                <ExpandMoreIcon style={{ fontSize: 30 }} />
              )}
              <div style={{ fontWeight: "500", fontSize: 20, marginLeft: 10 }}>
                {section[0].category}
              </div>
            </div>
            {this.genCustomerSection(section, section[0].category)}
          </>
        ))}
      </>
    );
  };
  genCustomerSection = (options, sectionTitle) => {
    if (
      !this.state.sectionsOpen.some(
        (eachOpenSection) => eachOpenSection === sectionTitle
      )
    )
      return "";
    else
      return (
        <Grid container spacing={2}>
          {options.map((tile) => (
            <Grid key={tile.title} item xs={12} md={4} lg={3}>
              <Button
                className="customerOptionList"
                variant="outlined"
                onClick={() => this.selectOption(tile.title, sectionTitle)}
              >
                {tile.title}
              </Button>
            </Grid>
          ))}
        </Grid>
      );
  };
  selectOption(optionSelected, tile) {
    if (!this.state.modalBoxState)
      this.setState({ optionSelected, modalBoxState: true });
    else
      this.setState({ modalBoxState: false }, () => {
        this.setState({ optionSelected, modalBoxState: true });
      });
    this.props.postAPIMessageSubjectCategory([optionSelected, tile]);
  }
  userTypeCheck() {
    // if user is employee
    if (this.props.getAPIEmployee === true) {
      this.props.history.push("compose");
      return;
    }
  }

  getContent() {
    let subject = this.props.getAPIMessage?.subject;
    return (
      <>
        <TextField
          inputRef={(ip) => (this.inputRef = ip)}
          variant="standard"
          style={{ width: "100%", marginBottom: "10px" }}
          label="Subject"
          value={subject === "Other" ? this.state.otherSubject : subject}
          onChange={(e) => {
            if (subject === "Other") {
              var newMessage = JSON.parse(
                JSON.stringify(this.props.getAPIMessage)
              );
              newMessage.subject = e.currentTarget.value;
              this.setState({ otherSubject: e.currentTarget.value });
            }
          }}
        />
        <p style={{ margin: "5px 0px" }}>Please type your message: </p>
        <div
          style={{
            position: "absolute",
            top: 5,
            right: 10,
            cursor: "pointer"
          }}
          onClick={() =>
            this.state.otherSubject !== "Other" ||
            (this.props.getAPIMessage.body !== "" &&
              this.props.getAPIMessage.body !== "\n")
              ? this.setState({
                  dialogState: true
                })
              : this.setState({ modalBoxState: false })
          }
        >
          <RiCloseLargeLine size={23} />
        </div>
        <div
          style={{
            border: "1px solid gray",
            minHeight: "6em",
            height: "50vh",
            overflow: "auto",
            padding: "5px"
          }}
          onClick={this.focusEditor}
        >
          <Editor
            ref={this.setEditor}
            editorState={this.state.editorState}
            onChange={(editorState) => {
              const blocks = convertToRaw(
                editorState.getCurrentContent()
              ).blocks;
              const text = blocks
                .map((block) => (!block.text.trim() && "\n") || block.text)
                .join("\n");

              var newMessage = JSON.parse(
                JSON.stringify(this.props.getAPIMessage)
              );
              newMessage.body = text;
              this.props.postAPIMessage(newMessage);
              this.setState({ editorState });
            }}
          />
        </div>
        <input
          ref={(ref) => (this.fileUploader = ref)}
          type="file"
          id="Attachments"
          name="Attachments"
          accept=".7z,.bmp,.csv,.doc,.docx,.jpeg,.jpg,.mov,.mp3,.mp4,.mpeg,.msg,.pdf,.png,.ppt,.pptx,.rar,.txt,.wav,.wmv,.xls,.xlsx,.zip"
          multiple
          style={{ display: "none" }}
          onChange={(action) => {
            var files = this.state.files.slice();
            if (action.currentTarget.files[0] !== undefined)
              files.push(action.currentTarget.files[0]);
            let filesWarn = false;
            if (files.length > 0) {
              files.map((eachFile) => {
                const regex = /[^0-9a-zA-Z._\s]/g;
                if (eachFile.name.match(regex)?.length > 0) {
                  let chars = eachFile.name.match(regex).map((i) => i);
                  this.setErrorMessage(
                    `${eachFile.name} has special characters, please remove them.(${chars})`
                  );
                  filesWarn = true;
                } else if (eachFile.size > maxFileSize) {
                  this.setErrorMessage(
                    "Your file is larger allowed limit of 25MB"
                  );
                  filesWarn = true;
                } else {
                  this.setErrorMessage();
                }
                return null;
              });
              if (!filesWarn) this.setState({ files });
            }
          }}
        ></input>
        <div style={{ margin: "5px 0px" }}>
          <AttachFileIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              this.fileUploader.click();
            }}
          />
          <span id="maxFileSizeName">
            MAX FileSize 25MB. Name can only include letters, numbers, periods,
            underscores, and spaces.
          </span>
        </div>
        {this.state.files && this.state.files.length > 0 ? (
          <Select
            isMulti
            style={{ width: "100%" }}
            name="Attachments"
            value={this.state.files.map((x, y) => {
              return { id: y, value: x, label: x.name, type: "file" };
            })}
            onChange={(i, y) => {
              let id = y.removedValue.id;
              let files = this.state.files.filter(
                (eachItem, index) => index !== id
              );
              this.setState({ files });
            }}
            className="basic-multi-select"
            classNamePrefix="select"
            components={{
              DropdownIndicator: DropdownIndicator,
              IndicatorSeparator: DropdownIndicator,
              Menu: DropdownIndicator,
              ClearIndicator: DropdownIndicator,
              Control: SelectContainer
            }}
          />
        ) : (
          ""
        )}
        {this.state.errorMSG ? (
          <>
            {this.state.files.length === 0 && <br />}
            <span id="errorMSG">{this.state.errorMSG}</span>
          </>
        ) : (
          ""
        )}
        <div style={{ width: "100%" }} className="Button">
          <Button
            onClick={() => {
              this.sendMessage();
            }}
            style={{ margin: "auto", width: "100px" }}
            variant="contained"
            className="ActionButton"
          >
            Send
          </Button>
        </div>
      </>
    );
  }
  render() {
    return (
      <div>
        <PopupAlert
          errorOpen={this.state.popupAlertOpen}
          handleErrorClose={() => {
            this.setState({ popupAlertOpen: false });
          }}
          errorMessage={this.state.popupAlertMessage}
          isSuccessMessage={this.state.popupAlertIsSuccessMessage}
        />
        <div
          style={{
            fontSize: 20,
            fontWeight: "600",
            marginBottom: 20,
            marginTop: 20,
            marginLeft: 30
          }}
        >
          What can we help you with?
        </div>
        <>
          <div id="CustomerOptions">{this.genCustomerSectionsList()}</div>
        </>
        {this.state.modalBoxState ? (
          <>
            <ModalBox
              isFlexWidth={true}
              Dialog={
                this.props.getAPIMessage.body &&
                this.props.getAPIMessage.body.length > 0
                  ? true
                  : false
              }
              CloseAction={() => this.resetBody()}
              CloseButton={true}
              Content={this.getContent()}
            />
          </>
        ) : (
          ""
        )}
        <SimpleBackdrop
          open={this.state.circularProgressOpen}
          onClick={this.handleCircularProgressClose}
        />
        <YesNoDialog
          open={this.state.yesNoDialogOpen}
          handleClose={(e) => {
            this.setState({ yesNoDialogOpen: false });
          }}
          handleYes={this.sendEmailConfirmed}
          content={this.state.yesNoDialogContent}
          title={this.state.yesNoDialogTitle}
          noBtnName={"Don't Send"}
          yesBtnName={"Send Anyway"}
        />
        <Dialog
          open={
            this.state.dialogState &&
            (this.state.otherSubject !== "Other" ||
              (this.props.getAPIMessage.body !== "" &&
                this.props.getAPIMessage.body !== "\n"))
          }
          title="Do you want to close and lose changes?"
          content=""
          noAction={() => this.setState({ dialogState: false })}
          yesAction={() => {
            this.setState({
              dialogState: false,
              modalBoxState: false,
              otherSubject: "Other",
              editorState: EditorState.createEmpty()
            });
            var newMessage = JSON.parse(
              JSON.stringify(this.props.getAPIMessage)
            );
            newMessage.body = "";
            this.props.postAPIMessage(newMessage);
          }}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    getAPIMessage: state.API.Message,
    getAPIEmployee: state.API.Employee,
    getAPIMailbox: state.API.Mailbox,
    getUserSettingsLocalDrafts: state.User.Settings.Local.Drafts
  };
}
const mapDispatchToProps = {
  postAPIMessages,
  postAPIMessage,
  postAPIDraft,
  postAPIMessageBody,
  postAPIMessageSubjectCategory,
  postUserSettingsGlobalSidebar,
  postUserSettingsLocal
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(ContactUsContent));
